module.exports = __webpack_public_path__ + "static/media/sodexo.af965143.webp";